// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__dPXPp","title":"Images90_title__3BA2Q","images":"Images90_images__2SWi6"};